import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _c91b0e90 = () => interopDefault(import('../pages/404-error.vue' /* webpackChunkName: "pages/404-error" */))
const _1b84dcd9 = () => interopDefault(import('../pages/admis.vue' /* webpackChunkName: "pages/admis" */))
const _552e67a9 = () => interopDefault(import('../pages/admis2.vue' /* webpackChunkName: "pages/admis2" */))
const _3e26ca16 = () => interopDefault(import('../pages/candidats.vue' /* webpackChunkName: "pages/candidats" */))
const _9040415c = () => interopDefault(import('../pages/contacter.vue' /* webpackChunkName: "pages/contacter" */))
const _9326171c = () => interopDefault(import('../pages/icfaDetails.vue' /* webpackChunkName: "pages/icfaDetails" */))
const _a614b826 = () => interopDefault(import('../pages/jobdating.vue' /* webpackChunkName: "pages/jobdating" */))
const _66597a2e = () => interopDefault(import('../pages/jpo.vue' /* webpackChunkName: "pages/jpo" */))
const _3bbd4d3a = () => interopDefault(import('../pages/mentionsLegales.vue' /* webpackChunkName: "pages/mentionsLegales" */))
const _6386770f = () => interopDefault(import('../pages/nosAtouts.vue' /* webpackChunkName: "pages/nosAtouts" */))
const _5736bfa7 = () => interopDefault(import('../pages/offreAlternanceTous.vue' /* webpackChunkName: "pages/offreAlternanceTous" */))
const _075e51d6 = () => interopDefault(import('../pages/offres_immediates.vue' /* webpackChunkName: "pages/offres_immediates" */))
const _5931f28c = () => interopDefault(import('../pages/politiqueDeConfidentialite.vue' /* webpackChunkName: "pages/politiqueDeConfidentialite" */))
const _4bcddd9e = () => interopDefault(import('../pages/sf.vue' /* webpackChunkName: "pages/sf" */))
const _25228d9b = () => interopDefault(import('../pages/sondage-csf.vue' /* webpackChunkName: "pages/sondage-csf" */))
const _2c61d952 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _44f64799 = () => interopDefault(import('../pages/admission/_jwt.vue' /* webpackChunkName: "pages/admission/_jwt" */))
const _2332172b = () => interopDefault(import('../pages/go/_go.vue' /* webpackChunkName: "pages/go/_go" */))
const _253ae77e = () => interopDefault(import('../pages/news/_news.vue' /* webpackChunkName: "pages/news/_news" */))
const _efc8e064 = () => interopDefault(import('../pages/_campusHP/index.vue' /* webpackChunkName: "pages/_campusHP/index" */))
const _ddc4d372 = () => interopDefault(import('../pages/_campusHP/campusDetail/index.vue' /* webpackChunkName: "pages/_campusHP/campusDetail/index" */))
const _2a1b4849 = () => interopDefault(import('../pages/_campusHP/contacter.vue' /* webpackChunkName: "pages/_campusHP/contacter" */))
const _a8694564 = () => interopDefault(import('../pages/_campusHP/lesAtouts.vue' /* webpackChunkName: "pages/_campusHP/lesAtouts" */))
const _56493b28 = () => interopDefault(import('../pages/_campusHP/offreAlternance/index.vue' /* webpackChunkName: "pages/_campusHP/offreAlternance/index" */))
const _6f834a42 = () => interopDefault(import('../pages/_campusHP/jpo/Journee-Portes-Ouvertes-4.vue' /* webpackChunkName: "pages/_campusHP/jpo/Journee-Portes-Ouvertes-4" */))
const _c0324778 = () => interopDefault(import('../pages/_campusHP/jpo/_jpo.vue' /* webpackChunkName: "pages/_campusHP/jpo/_jpo" */))
const _9af86ef8 = () => interopDefault(import('../pages/_campusHP/landing/_landing.vue' /* webpackChunkName: "pages/_campusHP/landing/_landing" */))
const _799606fd = () => interopDefault(import('../pages/_campusHP/offreAlternance/_offre.vue' /* webpackChunkName: "pages/_campusHP/offreAlternance/_offre" */))
const _6cdd22cc = () => interopDefault(import('../pages/_campusHP/_diploma/index.vue' /* webpackChunkName: "pages/_campusHP/_diploma/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404-error",
    component: _c91b0e90,
    name: "404-error"
  }, {
    path: "/admis",
    component: _1b84dcd9,
    name: "admis"
  }, {
    path: "/admis2",
    component: _552e67a9,
    name: "admis2"
  }, {
    path: "/candidats",
    component: _3e26ca16,
    name: "candidats"
  }, {
    path: "/contacter",
    component: _9040415c,
    name: "contacter"
  }, {
    path: "/icfaDetails",
    component: _9326171c,
    name: "icfaDetails"
  }, {
    path: "/jobdating",
    component: _a614b826,
    name: "jobdating"
  }, {
    path: "/jpo",
    component: _66597a2e,
    name: "jpo"
  }, {
    path: "/mentionsLegales",
    component: _3bbd4d3a,
    name: "mentionsLegales"
  }, {
    path: "/nosAtouts",
    component: _6386770f,
    name: "nosAtouts"
  }, {
    path: "/offreAlternanceTous",
    component: _5736bfa7,
    name: "offreAlternanceTous"
  }, {
    path: "/offres_immediates",
    component: _075e51d6,
    name: "offres_immediates"
  }, {
    path: "/politiqueDeConfidentialite",
    component: _5931f28c,
    name: "politiqueDeConfidentialite"
  }, {
    path: "/sf",
    component: _4bcddd9e,
    name: "sf"
  }, {
    path: "/sondage-csf",
    component: _25228d9b,
    name: "sondage-csf"
  }, {
    path: "/",
    component: _2c61d952,
    name: "index"
  }, {
    path: "/admission/:jwt?",
    component: _44f64799,
    name: "admission-jwt"
  }, {
    path: "/go/:go?",
    component: _2332172b,
    name: "go-go"
  }, {
    path: "/news/:news?",
    component: _253ae77e,
    name: "news-news"
  }, {
    path: "/:campusHP",
    component: _efc8e064,
    name: "campusHP"
  }, {
    path: "/:campusHP/campusDetail",
    component: _ddc4d372,
    name: "campusHP-campusDetail"
  }, {
    path: "/:campusHP/contacter",
    component: _2a1b4849,
    name: "campusHP-contacter"
  }, {
    path: "/:campusHP/lesAtouts",
    component: _a8694564,
    name: "campusHP-lesAtouts"
  }, {
    path: "/:campusHP/offreAlternance",
    component: _56493b28,
    name: "campusHP-offreAlternance"
  }, {
    path: "/:campusHP/jpo/Journee-Portes-Ouvertes-4",
    component: _6f834a42,
    name: "campusHP-jpo-Journee-Portes-Ouvertes-4"
  }, {
    path: "/:campusHP/jpo/:jpo?",
    component: _c0324778,
    name: "campusHP-jpo-jpo"
  }, {
    path: "/:campusHP/landing/:landing?",
    component: _9af86ef8,
    name: "campusHP-landing-landing"
  }, {
    path: "/:campusHP/offreAlternance/:offre",
    component: _799606fd,
    name: "campusHP-offreAlternance-offre"
  }, {
    path: "/:campusHP/:diploma",
    component: _6cdd22cc,
    name: "campusHP-diploma"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
